/**
 * Abstraction stockage local — un seul endroit à brancher sur Supabase plus tard.
 * Préfixe `athleos_` pour toutes les clés.
 */

import { logger } from "../utils/logger";

const PREFIX = "athleos_";
const LEGACY_APP_KEY = "atelier_v1";

/** Clé JSON principal (état app) — localStorage: athleos_app_state */
export const PERSISTENCE_APP_KEY = "app_state";

/** Clé complète pour adapters async (ex. Tauri) */
export const PERSISTENCE_APP_KEY_FULL = `${PREFIX}${PERSISTENCE_APP_KEY}`;

function safeParse(raw) {
  if (raw == null || raw === "") return null;
  try {
    return typeof raw === "string" ? JSON.parse(raw) : raw;
  } catch {
    return null;
  }
}

export const persistence = {
  /** État app complet (même objet qu’avant saveData). */
  getAppState() {
    try {
      const pref = localStorage.getItem(PREFIX + PERSISTENCE_APP_KEY);
      if (pref) return safeParse(pref);
      const leg = localStorage.getItem(LEGACY_APP_KEY);
      if (leg) {
        localStorage.setItem(PREFIX + PERSISTENCE_APP_KEY, leg);
        return safeParse(leg);
      }
      return null;
    } catch {
      return null;
    }
  },

  setAppState(data) {
    try {
      localStorage.setItem(PREFIX + PERSISTENCE_APP_KEY, JSON.stringify(data));
    } catch (e) {
      logger.warn("Persistence write failed", { detail: e?.message || e });
    }
  },

  get(key) {
    try {
      const raw = localStorage.getItem(PREFIX + key);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },

  set(key, value) {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
    } catch (e) {
      logger.warn("Persistence write failed", { detail: e?.message || e });
    }
  },

  remove(key) {
    localStorage.removeItem(PREFIX + key);
  },

  /** Liste ids nudges dismissés — migre athleon_* / athleos_* une fois. */
  getNudgesDismissed() {
    let v = persistence.get("nudges_dismissed");
    if (Array.isArray(v)) return v;
    try {
      const oldAthleon = localStorage.getItem("athleon_nudges_dismissed");
      if (oldAthleon) {
        const parsed = JSON.parse(oldAthleon);
        persistence.set("nudges_dismissed", Array.isArray(parsed) ? parsed : []);
        localStorage.removeItem("athleon_nudges_dismissed");
        return persistence.get("nudges_dismissed") || [];
      }
    } catch {
      /* ignore */
    }
    try {
      const legacy = localStorage.getItem("athleos_nudges_dismissed");
      if (legacy) {
        const parsed = JSON.parse(legacy);
        persistence.set("nudges_dismissed", Array.isArray(parsed) ? parsed : []);
        localStorage.removeItem("athleos_nudges_dismissed");
        return persistence.get("nudges_dismissed") || [];
      }
    } catch {
      /* ignore */
    }
    return [];
  },

  setNudgesDismissed(list) {
    persistence.set("nudges_dismissed", list);
  },
};

/** Accès tables Supabase (CRUD) — voir `supabasePersistence.js` */
export { persistenceApi, supabasePersistence } from "./supabasePersistence";
